import HeroSection from "./HeroSection";
import Features from "./Features";
import AdvancedFAQSection, { FAQS } from "./FaqsWebsite";
import ServiceHome from "./ServiceHome";
import CallToAction from "./CallToAction";
import LeadsManagementSection from "./LeadsManagementSection";
import Seo, { SITE_URL } from "./Seo";
import {
  ROUTES,
  organizationSchema,
  websiteSchema,
  softwareSchema,
  faqSchema,
} from "../seoData";

const PATH = "/";
const TITLE = ROUTES[PATH].title;
const DESCRIPTION = ROUTES[PATH].description;

const JSON_LD = [
  organizationSchema(),
  websiteSchema(),
  softwareSchema(),
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${SITE_URL}/#webpage`,
    url: `${SITE_URL}/`,
    name: TITLE,
    description: DESCRIPTION,
    inLanguage: "en-IN",
    isPartOf: { "@id": `${SITE_URL}/#website` },
    about: { "@id": `${SITE_URL}/#software` },
    primaryImageOfPage: { "@type": "ImageObject", url: `${SITE_URL}/og-image.png` },
  },
  faqSchema(FAQS),
];

const HomePage = () => {
  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path={PATH} jsonLd={JSON_LD} />
      <div className="w-full overflow-x-clip">
        <HeroSection />
        <ServiceHome />
        <Features />
        <LeadsManagementSection />
        <CallToAction />
        <AdvancedFAQSection />
      </div>
    </>
  );
};

export default HomePage;
